import React, {useEffect, useState}		from 'react';
import {useLocation, useNavigate}		from 'react-router-dom';
import {Link, Outlet}					from 'react-router-dom';

import Avatar 							from '../ressources/components/Avatar';
import Icon								from '../ressources/components/Icon';
import Modal							from '../ressources/components/Modal';
import Checkbox							from '../ressources/components/Checkbox';

import {useAppSelector, useAppDispatch}	from '../app/hooks';
import {logout, switchUserCompany}		from '../redux/user/user';
import {LanguageType}					from '../ressources/language/type';
import {ChildrenElement}				from '../ressources/typescript-declaration/global';
import {RightList}						from '../redux/user/interface';

import img_home							from '../ressources/images/icon/menu/home.svg';
import img_device						from '../ressources/images/icon/menu/device.svg';
import img_phone						from '../ressources/images/icon/menu/mobile-lines.svg';
import img_order						from '../ressources/images/icon/menu/order.svg';
import img_user							from '../ressources/images/icon/menu/user.svg';
import img_contract						from '../ressources/images/icon/menu/contract.svg';
import img_help							from '../ressources/images/icon/menu/help.svg';
import img_settings						from '../ressources/images/icon/menu/settings.svg';
import img_logout						from '../ressources/images/icon/menu/logout.svg';
import img_chevronSelector				from '../ressources/images/icon/chevron-selector-vertical.svg';
import img_homeRound					from '../ressources/images/icon/home.svg';

import useWindowSize					from '../ressources/functions/useWindowSize';
import {ft_checkRight}					from '../ressources/functions/userFunction';
import ft_cssVar						from '../ressources/functions/getCssVar';

import LANGUAGE							from '../ressources/language';

import './Menu.css';

interface MenuProps {
	notifContract: boolean
}


function	Menu(props: MenuProps) {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const company = useAppSelector(state => state.company.data);
	const lang = useAppSelector(state => state.settings.lang);

	const [open, set_open] = useState('close');
	const [modal, set_modal] = useState(false);
	const [newCompany, set_newCompany] = useState('');

	const navigate = useNavigate();
	const location = useLocation();
	const sizes = useWindowSize();
	const TEXTE = LANGUAGE(lang);

	useEffect(() => {
		if (modal)
			set_newCompany(company?._id || '');
	}, [modal]);

	function switchCompany() {
		if (newCompany === company?._id)
			return set_modal(false);

		dispatch(switchUserCompany(newCompany))
		.then(() => {
			set_modal(false);
			navigate('/home');
		});
	}

	function renderSwitchCompany() {
		if (user?.data?.otherCompanies?.length === 0)
			return;

		return (
			<div className={'menuItem'} onClick={() => set_modal(true)}>
				<div className={'menuItemIcon'}>
					<Icon
						iconSize={16}
						icon={img_chevronSelector}
						popup={open !== 'open' ? company?.name : undefined}
					/>
				</div>
				{open === 'open' &&
					<span className={'menuItemText text-md gray-700 weight-400'}>{company?.name}</span>
				}
			</div>
		);
	}

	function renderItem(value: keyof LanguageType['menu'], icon: string, right: RightList | '', notif?: boolean, forceLink?: string) {
		if (sizes.width < 767 && value !== 'logout' && value !== 'order')
			return;

		if (right && !ft_checkRight(user, right)) {
			if (user)
				return;

			return (
				<div data-disabled className={'menuItem'}>
					<div className={'menuItemIcon'}>
						<Icon
							icon={icon}
							popup={open !== 'open' ? TEXTE.menu[value] : undefined}
						/>
					</div>
					{open === 'open' &&
						<span className={'menuItemText text-md gray-700 weight-600'}>{TEXTE.menu[value]}</span>
					}
					{notif && <div className={'menuNotif'} />}
				</div>
			);
		}

		const actual = location.pathname.startsWith(`/${value}`);

		return (
			<Link
				className={'menuItem'}
				to={forceLink || `/${value}`}
				onClick={() => {
					if (sizes.width < 767)
						set_open('close');
					if (value === 'logout')
						dispatch(logout());
				}}
			>
				<div className={'menuItemIcon'}>
					<Icon
						icon={icon}
						iconSize={16}
						popup={open !== 'open' ? TEXTE.menu[value] : undefined}
						iconColor={actual ? ft_cssVar('primary-600') : ft_cssVar('gray-500')}
					/>
				</div>
				{open === 'open' &&
					<span className={`menuItemText text-md ${actual ? 'primary-600' : 'gray-700'} weight-600`}>{TEXTE.menu[value]}</span>
				}
				{notif && <div className={'menuNotif'} />}
				{(sizes.width < 767 && open === 'open') && <div className={'flex'} />}
			</Link>
		);
	}

	function renderModal() {
		const pushItem = (id: string, name?: string, address?: ChildrenElement) => {
			render.push(
				<div
					onClick={() => set_newCompany(id)}
					className={`globalDataContainerItem menuModalItem ${newCompany === id && 'active'}`}
				>
					<Icon
						icon={img_homeRound}
						className={'menuModalItemIcon'}
					/>
					<div className={'menuModalItemText'}>
						<span className={`weight-500 ${newCompany === id ? 'primary-800' : ''}`}>{name}</span>
						<span className={`${newCompany === id ? 'primary-700' : 'gray-500'}`}>{address}</span>
					</div>
					<Checkbox round active={newCompany === id} />
				</div>
			);
		};
		const render: React.ReactElement[] = [];

		pushItem(company?._id || '', company?.name);

		user?.data?.otherCompanies?.forEach(otherComp => pushItem(otherComp._id, otherComp.name, otherComp.address));

		return (
			<Modal
				size={600}
				footerSeparation
				confirmButton={switchCompany}
				onClose={() => set_modal(false)}
				cancelButton={() => set_modal(false)}
				header={
					<div>
						{TEXTE.menu.chooseAccount}<br />
						<span className={'text-sm weight-400 gray-600'}>{TEXTE.menu.selectAndConfirm}</span>
					</div>
				}
			>
				{render}
			</Modal>
		);
	}

	return (
		<>
			<div className={`menu ${open}`}>
				<div className={'menuLogo'} />
				{user && renderSwitchCompany()}

				<div
					className={'menuChevron'}
					onClick={() => set_open(open === 'open' ? 'close' : 'open')}
				/>

				{renderItem('home', img_home, 'self.read')}
				{renderItem('users', img_user, 'companyUsers.read')}
				{renderItem('devices', img_device, 'self.read')}
				{renderItem('order', img_order, 'company.read')}
				{renderItem('contracts', img_contract, 'company.read', props.notifContract)}
				{renderItem('mobileLines', img_phone, 'self.read')}
				{renderItem('support', img_help, 'self.read')}

				<div className={'flex'} />

				{renderItem('settings', img_settings, 'self.read')}
				{renderItem('logout', img_logout, '', false, '/')}

				<div className={'menuFooter'}>
					<Avatar user={user} size={32} />

					{open === 'open' &&
						<div className={'menuFooterTextContainer'}>
							<span>{`${user?.firstname || ''} ${user?.lastname || ''}`}</span>
							<span>{user?.email || ''}</span>
						</div>
					}
				</div>
			</div>
			<div className={'mainContent'}>
				<Outlet />
			</div>
			{modal && renderModal()}
		</>
	);
}

export default Menu;
